import { render, staticRenderFns } from "./event.mobile.vue?vue&type=template&id=973040d6&scoped=true&"
import script from "./event.mobile.vue?vue&type=script&lang=js&"
export * from "./event.mobile.vue?vue&type=script&lang=js&"
import style0 from "./event.mobile.vue?vue&type=style&index=0&id=973040d6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973040d6",
  null
  
)

export default component.exports